import React from 'react';
import { connect } from 'react-redux';

import SubHeader from './SubHeader';
import * as XLSX from 'xlsx';
import api from '../../api/api';
import uri from '../../variables/uri';
import history from '../../history';
import { setLoading } from '../../actions/authAction';
import FormSuggestApprover from '../forms/FormSuggestApprover'
import ConfirmDialogModal from '../modals/ConfirmDialogModal';
import AlertModal from '../modals/AlertModal';
import Dropzone from 'react-dropzone-uploader';
import util from '../../functions/Utilities';
 
class UploadDoa extends React.Component {
    state = {
        isOpen: false,
        message: '',
        text: '',
        typeAlert: 1,
        action: '',
        isOpenMessage: false,
        tempFiles:[],
        tempAllFiles:[],
        approverUserIdSelected:"",
        approverUserName:"",
        data:{},
        isGoInbox: false,
        isShowDetail: false,
        diffRows: [],
        pendingRequest: null,
        pendingBookCode: '',
        pendingBookReleaseId: null
    }

    componentDidMount = async () => {
        if (!this.props.isAuthen || (!this.props.auth.isAdmin && !this.props.auth.isEditor)) {
            history.push(`/home/${localStorage.getItem('username')}`)
        } 
        if(this.props.match.params.id === null || this.props.match.params.id === undefined){
            history.push(`/home/${localStorage.getItem('username')}`)
        }
        //this.props.match.params.id
        this.props.setLoading(true);
        try{
            var response = await api.get(`${uri.GET_REQUEST}?id=${this.props.match.params.id}`);
            if (response.status === 200) {
                this.setState({data: response.data});
                this.props.setLoading(false);
            }
        }catch(ex){
            this.setState({data: {}});
            this.props.setLoading(false);
        }
    }

    onBackPressed() {
        history.goBack();
    }
    // called every time a file's `status` changes
    handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }
    handleSubmit = async (files, allFiles) => {
        if(this.state.approverUserName === "" || this.state.approverUserIdSelected === undefined){
            this.setState({ isOpenMessage: true,message:"Please select an approver.",typeAlert:2});
            return;
        }
        if (!allFiles || allFiles.length === 0) {
            this.setState({ isOpenMessage: true,message:"Please attach an excel file.",typeAlert:2});
            return;
        }
        this.props.setLoading(true);
        try{
            const { arrReq, objReq, bookCode } = await this.parseExcelFile(allFiles[0].file);
            console.log('handleSubmit', arrReq, objReq, bookCode)
            if(this.props.match.params.id !== undefined && this.props.match.params.id !== null){
                if(objReq.RequestID === '' || this.props.match.params.id.toLowerCase() !== objReq.RequestID.toLowerCase()){
                    throw { message:'RequestID does not match.', typeAlert:2 };
                }
            }
            const { topics, bookReleaseId } = await this.loadCurrentBookData(bookCode);
            const diffRows = this.buildDiffRows(arrReq, topics);
            this.setState({
                tempAllFiles:allFiles,
                tempFiles:files,
                isOpen:true,
                message:'Review changes before submitting',
                text: diffRows.length === 0 ? 'No differences detected. Submit to continue.' : 'Compare the current version (left) with the uploaded version (right).',
                diffRows,
                pendingRequest: objReq,
                pendingBookCode: bookCode,
                pendingBookReleaseId: bookReleaseId
            });
        }catch(error){
            console.error(error);
            this.setState({ isOpenMessage: true,message:error.message || 'Unable to build comparison.',typeAlert:error.typeAlert || 3});
            allFiles.forEach(f => f.remove());
        }
        this.props.setLoading(false);
    }

    onUpload(){
        
    }

    parseExcelFile = (file) =>{
        return new Promise((resolve, reject)=>{
            var reader = new FileReader();
            reader.readAsBinaryString(file, "UTF-8");
            reader.onload = () => {
                try{
                    var data = reader.result;
                    let readedData = XLSX.read(data, { type: 'binary' });
                    const wsname = readedData.SheetNames[0];
                    const ws = readedData.Sheets[wsname];

                    const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    const excelArr = dataParse.filter((item, i) => item.length > 0 && i > 2);
                    const excelObj = dataParse.filter((item, i) => item.length > 0 && i === 1);

                    const arrReq = [];
                    excelArr.forEach(element => {
                        arrReq.push({
                            ReferenceID: (element[0] !== undefined && element[0] !== "") ? element[0] : null,
                            Action: (element[1] !== undefined && element[1] !== "") ? element[1] : '',
                            Book:(element[2] !== undefined && element[2] !== "") ? element[2] : null,
                            SubjectTitle: (element[3] !== undefined && element[3] !== "") ? element[3] : null,
                            SubjectTypeID: (element[4] !== undefined && element[4] !== "") ? element[4] : null,
                            SubjectTypeTitle: (element[5] !== undefined && element[5] !== "") ? element[5] : null,
                            TopicNo: (element[6] !== undefined && element[6] !== "") ? element[6] : null,
                            TopicTitle: (element[7] !== undefined && element[7] !== "") ? element[7] : null,
                            ConditionTitle: (element[8] !== undefined && element[8] !== "") ? element[8] : null,
                            Type: (element[9] !== undefined && element[9] !== "") ? element[9] : null,
                            Operation: (element[10] !== undefined && element[10] !== "") ? element[10] : null,
                            Value: (element[11] !== undefined && element[11] !== "") ? element[9] === "Amount" || element[9] === "A" ? element[11].toString().replace(/,/g, '') : element[11] : null,
                            Approve: (element[12] !== undefined && element[12] !== "") ? element[12] : null,
                            ApproveText: (element[13] !== undefined && element[13] !== "") ? element[13] : null,
                            Sign: (element[14] !== undefined && element[14] !== "") ? element[14] : null,
                            SignText: (element[15] !== undefined && element[15] !== "") ? element[15] : null,
                            Report: (element[16] !== undefined && element[16] !== "") ? element[16] : null,
                            ReportText: (element[17] !== undefined && element[17] !== "") ? element[17] : null,
                            Remark: (element[18] !== undefined && element[18] !== "") ? element[18] : null,
                            Comment: (element[19] !== undefined && element[19] !== "") ? element[19] : null
                        });
                    });
                    const objReq = {
                        RequestNo:(excelObj[0][0] !== undefined && excelObj[0][0] !== "") ? excelObj[0][0] : '',
                        RequestID:(excelObj[0][1] !== undefined && excelObj[0][1] !== "") ? excelObj[0][1] : '',
                        RequestUserID:(excelObj[0][3] !== undefined && excelObj[0][3] !== "") ? excelObj[0][3] : '',
                        ApproverUserID: this.state.approverUserIdSelected,
                        ApproverFullName: this.state.approverUserName,
                        SubmitUserID:localStorage.getItem('username'),
                        SubmitUserFullName:this.props.auth.name,
                        DoaList: arrReq
                    }
                    console.log('arrReq', arrReq);
                    const bookFromExcel = arrReq.find(item => item.Book !== null && item.Book !== undefined && item.Book !== '');
                    console.log('bookFromExcel', bookFromExcel);
                    if(!bookFromExcel){
                        reject({message:'Book is required in the uploaded file.', typeAlert:2});
                        return;
                    }
                    const bookCode = bookFromExcel.Book
                    resolve({ arrReq, objReq, bookCode });
                }catch(ex){
                    reject(ex);
                }
            }
            reader.onerror = () => reject({message:'Unable to read uploaded file.', typeAlert:3});
        });
    }

    loadCurrentBookData = async (bookCode) =>{
        const bookListResponse = await api.get(`${uri.GET_BOOK_LIST}`);
        if(bookListResponse.status !== 200){
            throw {message:'Unable to load book list.', typeAlert:3};
        }
        console.log(bookListResponse, bookCode, '**********')
        const foundBook = bookListResponse.data.find(item => item.BookCode === bookCode);
        if(!foundBook){
            throw {message:'Book not found in system.', typeAlert:2};
        }
        let editor = this.props.auth.isAdmin || this.props.auth.isEditor ? 'true' : 'false';
        const topicResponse = await api.get(`${uri.GET_TOPIC_LIST_BY_BOOK}?BookReleaseId=${foundBook.BookReleaseId}&Editor=${editor}`);
        if(topicResponse.status !== 200){
            throw {message:'Unable to load current book data.', typeAlert:3};
        }
        return { topics: topicResponse.data || [], bookReleaseId: foundBook.BookReleaseId };
    }

    buildDiffKey = (subject, subjectType, topicNo, condition) =>{
        const normalize = (value) => value === undefined || value === null ? '' : value.toString().trim().toLowerCase();
        return `${normalize(subject)}::${normalize(subjectType)}::${normalize(topicNo)}::${normalize(condition)}`;
    }

    normalizeValue = (value) =>{
        if(value === null || value === undefined) return '';
        if(typeof value === 'string') return value.trim();
        return value.toString();
    }

    buildDiffRows = (uploadedList, currentList) =>{
        const uploadedMap = {};
        const currentMap = {};
        const currentRefMap = {};
        const normalizeRef = (value) => {
            if(value === undefined || value === null) return null;
            return value.toString().trim().toLowerCase();
        };
        uploadedList.forEach(item =>{
            const key = this.buildDiffKey(item.SubjectTitle, item.SubjectTypeID, item.TopicNo, item.ConditionTitle);
            uploadedMap[key] = item;
        });
        currentList.forEach(item =>{
            const key = this.buildDiffKey(item.SubjectTitle, item.SubjectTypeID, item.TopicNo, item.CondTitle);
            if(!currentMap[key]){
                currentMap[key] = item;
            }
            const refId = normalizeRef(item.ConditionRefID || item.TopicRefID || item.ReferenceID);
            if(refId && !currentRefMap[refId]){
                currentRefMap[refId] = item;
            }
        });
        const fields = [
            { label:'Subject', newKey:'SubjectTitle', currentKey:'SubjectTitle' },
            { label:'Subject Type', newKey:'SubjectTypeTitle', currentKey:'SubjectTypeTitle' },
            { label:'Topic No', newKey:'TopicNo', currentKey:'TopicNo' },
            { label:'Topic Title', newKey:'TopicTitle', currentKey:'TopicTitle' },
            { label:'Condition', newKey:'ConditionTitle', currentKey:'CondTitle' },
            { label:'Type', newKey:'Type', currentKey:'Type' },
            { label:'Operation', newKey:'Operation', currentKey:'Operation' },
            { label:'Value', newKey:'Value', currentKey:'Value' },
            { label:'Approve', newKey:'Approve', currentKey:'Approval' },
            { label:'Approve Text', newKey:'ApproveText', currentKey:'ApprovalText' },
            { label:'Sign', newKey:'Sign', currentKey:'Sign' },
            { label:'Sign Text', newKey:'SignText', currentKey:'SignText' },
            { label:'Report', newKey:'Report', currentKey:'Report' },
            { label:'Report Text', newKey:'ReportText', currentKey:'ReportText' },
            { label:'Remark', newKey:'Remark', currentKey:'Remark' },
            { label:'Comment', newKey:'Comment', currentKey:'Comments' },
            { label:'Action', newKey:'Action', currentKey:'Action' },
        ];
        const keys = Object.keys(uploadedMap);
        const rows = [];
        keys.forEach(key =>{
            let currentItem = currentMap[key];
            const uploadedItem = uploadedMap[key];
            if(!currentItem){
                const refId = normalizeRef(uploadedItem.ReferenceID);
                if(refId && currentRefMap[refId]){
                    currentItem = currentRefMap[refId];
                }
            }
            if(!currentItem && !uploadedItem) return;
            const status = !currentItem ? 'added' : !uploadedItem ? 'removed' : 'modified';
            const changes = fields.map(field =>{
                const currentValue = this.normalizeValue(currentItem ? currentItem[field.currentKey] : '');
                const newValue = this.normalizeValue(uploadedItem ? uploadedItem[field.newKey] : '');
                return {
                    ...field,
                    currentValue: currentValue === '' ? '-' : currentValue,
                    newValue: newValue === '' ? '-' : newValue,
                    changed: currentValue !== newValue
                }
            }).filter(field => status === 'modified' ? field.changed : true);
            if(status !== 'modified' || changes.length > 0){
                rows.push({
                    key,
                    status,
                    title: this.buildDiffTitle(currentItem || uploadedItem),
                    changes
                });
            }
        });
        return rows;
    }

    buildDiffTitle = (item) =>{
        if(!item) return '';
        const subject = item.SubjectTitle || '-';
        const topicNo = item.TopicNo || '';
        const topicTitle = item.TopicTitle ? ` ${item.TopicTitle}` : '';
        const condition = item.ConditionTitle || item.CondTitle;
        const conditionText = condition ? ` (${condition})` : '';
        return `${subject} / ${topicNo}${topicTitle}${conditionText}`;
    }

    onSubmit = async () =>{
        this.props.setLoading(true);
        this.setState({ isOpen: false});
        try {
            let payload = this.state.pendingRequest;
            if(!payload && this.state.tempAllFiles && this.state.tempAllFiles.length > 0){
                const parsed = await this.parseExcelFile(this.state.tempAllFiles[0].file);
                payload = parsed.objReq;
            }
            if(!payload){
                throw {message:'No upload data found to submit.', typeAlert:2};
            }
            const objReq = {
                ...payload,
                ApproverUserID: this.state.approverUserIdSelected,
                ApproverFullName: this.state.approverUserName,
                SubmitUserID:localStorage.getItem('username'),
                SubmitUserFullName:this.props.auth.name,
            }
            let checkRequestId = true;
            if(this.props.match.params.id !== undefined && this.props.match.params.id !== null){
                if(objReq.RequestID === '' || this.props.match.params.id.toLowerCase() !== objReq.RequestID.toLowerCase()){
                    checkRequestId = false;
                }
            }
            if(checkRequestId){
                var response = await api.post(uri.POST_CHECK_IN_DOA, objReq);
                if (response.status === 200) {
                    if(response.data.Code === "00"){
                        this.setState({isOpenMessage:true, message: 'Checkin successfully.', typeAlert:1, isGoInbox:true});
                    }
                    else if(response.data.Code === "99"){
                        this.setState({isOpenMessage:true, message: response.data.Message, typeAlert:3});
                    }else if(response.data.Code === "02"){
                        this.setState({isOpenMessage:true, message: response.data.Message, typeAlert:2, isGoInbox:true, isShowDetail: true});
                    }else{
                        this.setState({isOpenMessage:true, message: response.data.Message, typeAlert:2});
                    }
                }
            }else{
                this.setState({isOpenMessage:true, message: 'RequestID does not match.', typeAlert:2});
            }
            
        } catch (ex) {
            console.error(ex);
            this.setState({isOpenMessage:true, message: ex.Message || ex.message || 'Upload failed.', typeAlert: ex.typeAlert || 3});
        }
        this.props.setLoading(false);
        if(this.state.tempAllFiles){
            this.state.tempAllFiles.forEach(f => f.remove());
        }
    }

    onCloseModal = () =>{
        this.setState({ isOpen: false, isOpenMessage: false});
        if(this.state.isGoInbox && this.state.isShowDetail){
            history.push(`/Search/Request/Inbox/${this.props.match.params.id}`)
        }else if(this.state.isGoInbox){
            //history.goBack();
            history.push(`/Search/Request/Inbox`)
        }
    }
    onHandleSelect = async (value) => {
        if (value === undefined) {
            this.setState({ approverUserName:"", approverUserIdSelected:""});
        } else {
            this.setState({ approverUserName: `${value.FirstNameEN} ${value.LastNameEN}`,approverUserIdSelected:value.UserID });
        }
    }

    renderDiffPreview = () =>{
        const statusColor = {
            added: '#e6ffed',
            removed: '#ffecec',
            modified: '#fff7e6'
        };
        if(!this.state.isOpen) return null;
        return (
            <div className="mt-8" style={{maxHeight:'50vh', overflowY:'auto'}}>
                {this.state.pendingBookCode && <div className="mb-8 text-left"><strong>Book:</strong> {this.state.pendingBookCode} {this.state.pendingBookReleaseId && `(Release ${this.state.pendingBookReleaseId})`}</div>}
                {this.state.diffRows.length === 0 &&
                    <div className="p-12" style={{background:'#f5f5f5', borderRadius:'8px', textAlign:'center'}}>No differences found.</div>
                }
                {this.state.diffRows.map(item=>{
                    const badgeText = item.status === 'added' ? 'New' : item.status === 'removed' ? 'Removed' : 'Modified';
                    return (
                        <div key={item.key} className="card mt-8" style={{padding:'12px', textAlign:'left'}}>
                            <div className="flex-h flex-between flex-center">
                                <div>
                                    <h5 className="text-bold">{item.title}</h5>
                                </div>
                                <div style={{background: statusColor[item.status], padding:'4px 10px', borderRadius:'12px', fontWeight:600}}>
                                    {badgeText}
                                </div>
                            </div>
                            <div className="flex-h mt-8">
                                <div className="flex-1 mr-4">
                                    <div className="text-bold mb-4">Current</div>
                                    {item.changes.map(change=>(
                                        <div key={`current-${item.key}-${change.label}`} style={{marginBottom:'6px', padding:'6px 8px', borderRadius:'6px', background: change.changed ? '#ffecec' : '#f9f9f9'}}>
                                            <div className="is-size-7 has-text-grey">{change.label}</div>
                                            <div>{change.currentValue}</div>
                                        </div>
                                    ))}
                                </div>
                                <div className="flex-1 ml-4">
                                    <div className="text-bold mb-4">Uploaded</div>
                                    {item.changes.map(change=>(
                                        <div key={`uploaded-${item.key}-${change.label}`} style={{marginBottom:'6px', padding:'6px 8px', borderRadius:'6px', background: change.changed ? '#e6ffed' : '#f9f9f9'}}>
                                            <div className="is-size-7 has-text-grey">{change.label}</div>
                                            <div>{change.newValue}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }

    render() {
        return (
            <div className="flex-v home">
                <SubHeader text={`Upload Doa`} />
                <div className="flex-v flex-1">
                    <div className="flex-v">
                        <div className="flex-h mt-16 ml-24" style={{ alignItems: 'center' }}>
                            {/* <img src={uploadfileImg} alt="" style={{ height: '25px' }} />
                            <h3 className="ml-16 text-center">Upload</h3> */}
                        </div>
                        <div className="flex-v card ml-16 mr-16 p-16 text-center">
                            <div className='flex-v mt-16'>
                                <div className='flex-h'>
                                    <div className="flex-v flex-center pr-8">
                                        <h4 className='text-bold'>Request No.  </h4>
                                    </div>
                                    <div className="flex-1 text-left">
                                        <h4>{this.state.data.RequestNo}</h4>
                                    </div>
                                </div>   
                            </div>
                            <div className='flex-v mt-16'>
                                <div className='flex-h'>
                                    <div className="flex-v flex-center pr-32">
                                        <h4 className='text-bold'>Note  &nbsp; &nbsp;</h4>
                                    </div>
                                    <div className="flex-1 text-left">
                                        <h4>{this.state.data.Note}</h4>
                                    </div>
                                </div>   
                            </div>
                            <FormSuggestApprover
                                name="Approver"
                                handleSelect={this.onHandleSelect}
                                value={this.state.approverUserName}
                                />
                            <div className='flex-v mt-16'>
                                <div className='flex-h'>
                                    <div className="flex-v flex-center pr-16">
                                        <h4 className='text-bold'>Upload  &nbsp; &nbsp;</h4>
                                    </div>
                                    <Dropzone
                                        onChangeStatus={this.handleChangeStatus}
                                        onSubmit={this.handleSubmit}
                                        accept=".csv,.xls,.xlsx"
                                        maxFiles={1}
                                        multiple={false}
                                        inputContent="Drag and Drop File or Click to Browse file"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onCloseModal} type={this.state.typeAlert} />
                <ConfirmDialogModal isOpen={this.state.isOpen} message={this.state.message} onConfirm={this.onSubmit} onClose={this.onCloseModal} text={this.state.text}>
                    {this.renderDiffPreview()}
                </ConfirmDialogModal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthen: state.auth.isAuthen,
        type: state.doa.type,
        doa: state.doa.doa,
        book: state.doa.queryBook,
        auth: state.auth,
        user: state.doa.user
    }
}
export default connect(mapStateToProps,{setLoading})(UploadDoa);
